
import React from "react";

const HubspotIcon = ({ className = "", size = 24, ...props }: React.HTMLAttributes<HTMLImageElement> & { size?: number }) => {
  return (
    <img
      src="https://images.clickfunnels.com/cdn-cgi/image/width=800,fit=scale-down,f=auto,q=80/https://statics.myclickfunnels.com/workspace/vMBPdQ/image/9069700/file/95fcda0dd16959ca62a29094e6d8ecc9.png"
      alt="Hubspot Partner Platinum"
      width={size} 
      height={size}
      className={`object-contain ${className}`}
      {...props}
    />
  );
};

export default HubspotIcon;
